import { ReactNode, Ref } from 'react';
import { BoxArrowUpRight, DoorOpenFill, GearFill } from 'react-bootstrap-icons';
import { Button, Col, Container, Row } from 'react-bootstrap';

export interface HeaderMenuItem {
  key: string;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  href?: string;
  newTab?: boolean;
  showExternalIcon?: boolean;
  targetRef?: Ref<any>;
}

interface Props {
  displayLines: string[];
  menuItems: HeaderMenuItem[];
  onClickLogo: () => void;
  onClickInfo: () => void;
  onClickLogout: () => void;
  showOpinionAction?: boolean;
  menuSupplement?: ReactNode;
}

const CommonHeader: React.FC<Props> = ({
  displayLines,
  menuItems,
  onClickLogo,
  onClickInfo,
  onClickLogout,
  showOpinionAction = false,
  menuSupplement,
}) => {
  const renderMenuItem = (item: HeaderMenuItem) => {
    if (item.href) {
      return (
        <a key={item.key} href={item.href} target={item.newTab ? '_blank' : undefined} rel={item.newTab ? 'noreferrer' : undefined}>
          <Button variant="primary" type="button" className="m-1 header-menu-btn">
            {item.label}
            {item.showExternalIcon && <BoxArrowUpRight size={15} className="document-icon" />}
          </Button>
        </a>
      );
    }

    return (
      <Button
        key={item.key}
        ref={item.targetRef}
        variant="primary"
        className="m-1 header-menu-btn"
        as="input"
        type="button"
        value={item.label}
        onClick={item.onClick}
        disabled={item.disabled}
      />
    );
  };

  const renderActionButtons = (includeOpinion: boolean) => (
    <>
      {includeOpinion && (
        <div className="mr-3 header-opinion-item">
          <a href="https://sartras.or.jp/tsumugi/opinion/" target="_blank" rel="noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/post.png`} className="header-opinion-icon" />
          </a>
          <div className="header-action-label header-opinion-label">ご意見</div>
        </div>
      )}
      <div className="mr-1">
        <GearFill size={24} onClick={onClickInfo} className="d-block m-auto cursor-pointer header-action-icon" />
        <div className="header-action-label">設定</div>
      </div>
      <div>
        <DoorOpenFill size={24} onClick={onClickLogout} className="d-block m-auto cursor-pointer header-action-icon" />
        <div className="header-action-label">ログアウト</div>
      </div>
    </>
  );

  return (
    <Container className="base-header mt-2 mb-3">
      <Row>
        <Col md="12" lg="3" xl="3" className="header-logo-column">
          <img
            src={`${process.env.PUBLIC_URL}/images/new_sartras_logo.png`}
            alt="sartras_logo"
            className="header-logo"
            onClick={onClickLogo}
            style={{ cursor: 'pointer' }}
          />
        </Col>
        <Col md="12" lg="9" xl="9" className="d-flex flex-column">
          <div>
            <Container>
              <Row>
                <Col md="9" lg="12" className="displayName-position">
                  {displayLines.map((line, index) => (
                    <div key={`${line}-${index}`} className="header-user-line">
                      {line}
                    </div>
                  ))}
                </Col>
              </Row>
            </Container>
          </div>
          <div>
            <Container>
              <Row className="header-bottom-row">
                <Col md="12" lg="9" className="header-menu-section header-menu-buttons-col">
                  {menuItems.map(renderMenuItem)}
                  {menuSupplement}
                </Col>
                <Col className="p-0 my-2 lager-settings header-actions-col">{renderActionButtons(showOpinionAction)}</Col>
              </Row>
            </Container>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CommonHeader;
